import React from 'react';

import styled from 'styled-components';

// constants
import aampeTheme from '../../../constants/aampeTheme';

interface AampeItalicTextProps {
    text: string;
}

const AampeItalicText: React.FC<React.PropsWithChildren<AampeItalicTextProps>> =
    ({ text }) => {
        return <ItalicText>{text}</ItalicText>;
    };

export default AampeItalicText;

const ItalicText = styled.span({
    color: aampeTheme.colors.solidA02,
    fontSize: '16px',
    fontStyle: 'italic',
    fontWeight: 400,
    lineHeight: '20px',
});
